/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespRefineMenu_viewer$ref = any;
export type SbRespRefineMenuSelector_viewer$ref = any;
export type SbRespRefineMenuSelector_viewer = {
    readonly isSkyscraperAdEnabled: boolean | null;
    readonly " $fragmentRefs": SbRespRefineMenu_viewer$ref;
    readonly " $refType": SbRespRefineMenuSelector_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuSelector_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isSkyscraperAdEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "NON_MVP_SEARCH_BROWSE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "SbRespRefineMenu_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'd3a47ebbc267d4afe1733afffd5946ac';
export default node;
